import { differenceInSeconds, sub } from 'date-fns'
import { milliseconds } from 'date-fns'
import { DROPOFF, GO_TO_GARAGE_IN_NO_SCHEDULED_DRIVE_THRESHOLD_SECONDS } from './dropoffConstants'

/**
 * NoScheduledDrive: show GoToGarage when "time to leave for garage" is within the configured threshold.
 * Uses drive duration to garage when available so the threshold is drive-aware; otherwise uses BUFFER_SECONDS.
 */
export function shouldShowGoToGarageInNoScheduledDrive(
  dropoffTime: string | undefined,
  now: Date,
  dropoffDriveDurationSeconds?: number
): boolean {
  if (dropoffTime == null) return false
  const dropoffDate = new Date(dropoffTime)
  const leaveByDate = sub(dropoffDate, { seconds: dropoffDriveDurationSeconds ?? DROPOFF.BUFFER_SECONDS })
  const secondsUntilLeaveBy = differenceInSeconds(leaveByDate, now)
  return secondsUntilLeaveBy <= GO_TO_GARAGE_IN_NO_SCHEDULED_DRIVE_THRESHOLD_SECONDS
}

/**
 * TimeToDropoffAlert: visible only when 0 < secondsToDropoffStart <= TIME_TO_DROPOFF_ALERT_MAX_MINUTES.
 */
export function isTimeToDropoffAlertVisible(secondsToDropoffStart: number): boolean {
  const maxMs = milliseconds({ minutes: DROPOFF.TIME_TO_DROPOFF_ALERT_MAX_MINUTES })
  const ms = secondsToDropoffStart * 1000
  return ms > 0 && ms <= maxMs
}

/**
 * TimeToDropoffAlert: use detailed message when more than this many minutes to dropoff start.
 */
export function isTimeToDropoffDetailedMessage(secondsToDropoffStart: number): boolean {
  const ms = secondsToDropoffStart * 1000
  return ms > milliseconds({ minutes: DROPOFF.TIME_TO_DROPOFF_DETAILED_MESSAGE_MINUTES })
}
